import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: "ColorGridMemory",
  props: {
    timeline: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 3
    },
    showMs: {
      type: Number,
      default: 1000
    },
    gapMs: {
      type: Number,
      default: 500
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    reviewAnswer: {
      type: String,
      default: ''
    },
    autoPlaySignal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stage: this.reviewMode ? 'done' : 'idle',
      activeCell: null,
      activeColor: null,
      answers: [],
      timers: []
    };
  },
  computed: {
    cells() {
      return Array.from({
        length: this.size * this.size
      }, (_, index) => index);
    },
    answerOrderMap() {
      const map = {};
      this.answers.forEach((cell, index) => {
        map[cell] = index;
      });
      return map;
    }
  },
  watch: {
    timeline: {
      deep: true,
      handler() {
        this.resetState();
      }
    },
    size() {
      this.resetState();
    },
    reviewMode() {
      this.resetState();
    },
    reviewAnswer() {
      this.resetState();
    },
    autoPlaySignal() {
      if (this.reviewMode && this.autoPlaySignal > 0) {
        this.playReviewTimeline();
      }
    }
  },
  methods: {
    clearTimers() {
      this.timers.forEach(timer => clearTimeout(timer));
      this.timers = [];
    },
    parseAnswer(answer) {
      if (!answer) {
        return [];
      }
      return answer.split(',').map(item => item.trim()).filter(item => item !== '').map(item => Number(item)).filter(item => !Number.isNaN(item));
    },
    resetState() {
      this.clearTimers();
      this.activeCell = null;
      this.activeColor = null;
      this.answers = this.reviewMode ? this.parseAnswer(this.reviewAnswer) : [];
      this.stage = this.reviewMode ? 'done' : 'idle';
      this.emitAnswer();
    },
    startPlayback() {
      if (!this.timeline.length) {
        this.stage = 'answering';
        return;
      }
      this.clearTimers();
      this.answers = [];
      this.emitAnswer();
      this.stage = 'playing';
      this.activeCell = null;
      this.activeColor = null;
      let offset = 0;
      this.timeline.forEach(event => {
        const startTimer = setTimeout(() => {
          this.activeCell = event.cellIndex;
          this.activeColor = event.color;
        }, offset);
        this.timers.push(startTimer);
        offset += Number(this.showMs || 1000);
        const endTimer = setTimeout(() => {
          this.activeCell = null;
          this.activeColor = null;
        }, offset);
        this.timers.push(endTimer);
        offset += Number(this.gapMs || 500);
      });
      const finishTimer = setTimeout(() => {
        this.stage = 'answering';
      }, offset);
      this.timers.push(finishTimer);
    },
    playReviewTimeline() {
      if (!this.timeline.length) {
        return;
      }
      this.clearTimers();
      this.activeCell = null;
      this.activeColor = null;
      this.stage = 'playing';
      let offset = 0;
      this.timeline.forEach(event => {
        const startTimer = setTimeout(() => {
          this.activeCell = event.cellIndex;
          this.activeColor = event.color;
        }, offset);
        this.timers.push(startTimer);
        offset += Number(this.showMs || 1000);
        const endTimer = setTimeout(() => {
          this.activeCell = null;
          this.activeColor = null;
        }, offset);
        this.timers.push(endTimer);
        offset += Number(this.gapMs || 500);
      });
      const finishTimer = setTimeout(() => {
        this.stage = 'done';
      }, offset);
      this.timers.push(finishTimer);
    },
    onCellClick(cell) {
      if (this.stage !== 'answering' || this.reviewMode) {
        return;
      }
      this.answers.push(cell);
      this.emitAnswer();
      if (this.answers.length >= this.redAnswerLength()) {
        this.stage = 'done';
      }
    },
    redAnswerLength() {
      return this.timeline.filter(item => item.color === 'red').length;
    },
    emitAnswer() {
      const answer = this.answers.length === this.redAnswerLength() ? this.answers.join(',') : null;
      this.$emit('answer', answer);
    },
    undoLast() {
      if (!this.answers.length) {
        return;
      }
      this.answers.pop();
      this.emitAnswer();
    },
    clearAnswers() {
      this.answers = [];
      this.emitAnswer();
    },
    cellStyle(cell) {
      if (this.activeCell !== cell) {
        return {};
      }
      return {
        backgroundColor: this.activeColor === 'red' ? '#e74c3c' : '#3498db',
        borderColor: this.activeColor === 'red' ? '#e74c3c' : '#3498db'
      };
    }
  },
  mounted() {
    this.resetState();
  },
  beforeUnmount() {
    this.clearTimers();
  }
};